/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Call_FailedInputs */

const en_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool call failed`)
};

const ar_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل استدعاء الأداة`)
};

const bn_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল কল ব্যর্থ হয়েছে`)
};

const de_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-Aufruf fehlgeschlagen`)
};

const es_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al llamar a la herramienta`)
};

const fr_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'appel d'outil`)
};

const pt_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na chamada da ferramenta`)
};

const zh_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具调用失败`)
};

const tr_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç çağrısı başarısız oldu`)
};

const ru_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось вызвать инструмент`)
};

const pl_chat_tool_call_failed = /** @type {(inputs: Chat_Tool_Call_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wywołanie narzędzia nie powiodło się`)
};

/**
* | output |
* | --- |
* | "Tool call failed" |
*
* @param {Chat_Tool_Call_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_tool_call_failed = /** @type {((inputs?: Chat_Tool_Call_FailedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Call_FailedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_tool_call_failed(inputs)
	if (locale === "bn") return bn_chat_tool_call_failed(inputs)
	if (locale === "de") return de_chat_tool_call_failed(inputs)
	if (locale === "es") return es_chat_tool_call_failed(inputs)
	if (locale === "fr") return fr_chat_tool_call_failed(inputs)
	if (locale === "pt") return pt_chat_tool_call_failed(inputs)
	if (locale === "zh") return zh_chat_tool_call_failed(inputs)
	if (locale === "tr") return tr_chat_tool_call_failed(inputs)
	if (locale === "ru") return ru_chat_tool_call_failed(inputs)
	if (locale === "pl") return pl_chat_tool_call_failed(inputs)
	return en_chat_tool_call_failed(inputs)
});